module.exports = __webpack_public_path__ + "img/mother.be5030ca.webp";